'use strict';

const ActionStatus = Object.freeze({
    NONE: "NONE",
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED'
});

const ScheduleRate = Object.freeze({
    MINUTES: 'minutes',
    HOURS: 'hours',
    DAYS: 'days'
});

const SURVIVORSHIP_RULES = Object.freeze({
    ALWAYS_SOURCE: 'ALWAYS_SOURCE',
    UPDATE_IF_SOURCE_NOT_NULL: 'UPDATE_IF_SOURCE_NOT_NULL',
    RETAIN_LOCAL: 'RETAIN_LOCAL',
    FILL_LOCAL_BLANKS: 'FILL_LOCAL_BLANKS',
    SMART_MERGE_PREFER_LOCAL: 'SMART_MERGE_PREFER_LOCAL',
    SMART_MERGE_PREFER_SOURCE: 'SMART_MERGE_PREFER_SOURCE'
});

module.exports = {
    ActionStatus,
    ScheduleRate,
    SURVIVORSHIP_RULES
};